import { render, staticRenderFns } from "./SetupTourIntroModal.vue?vue&type=template&id=3135869f&scoped=true"
import script from "./SetupTourIntroModal.vue?vue&type=script&lang=js"
export * from "./SetupTourIntroModal.vue?vue&type=script&lang=js"
import style0 from "./SetupTourIntroModal.vue?vue&type=style&index=0&id=3135869f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3135869f",
  null
  
)

export default component.exports